"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.variants = exports.default = void 0;
var _merge = _interopRequireDefault(require("lodash/merge"));
var _theme = _interopRequireDefault(require("@chakra-ui/theme"));
const baseStyle = {
  px: 8,
  py: 3,
  fontSize: 'base',
  fontFamily: 'body',
  lineHeight: 0.875,
  fontWeight: 'semibold',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderRadius: '1.25rem',
  textTransform: 'capitalize',
  transition: 'all normal ease',
  _disabled: {
    cursor: 'not-allowed',
    opacity: 1,
    bg: 'gray.medium',
    borderColor: 'gray.medium',
    color: 'gray.dark'
  },
  '& svg': {
    display: 'block'
  }
};
// TODO: We need an active styling
const disabledButtonHoverStyle = {
  _disabled: {
    bg: 'gray.medium',
    borderColor: 'gray.medium',
    color: 'gray.dark'
  }
};
const destructiveButtonStyles = {
  bg: 'white',
  borderColor: 'red.default',
  color: 'red.default',
  _hover: {
    borderColor: 'red.800',
    color: 'red.800',
    ...disabledButtonHoverStyle
  }
};
const variants = exports.variants = {
  primary: {
    bg: 'primary.default',
    borderColor: 'primary.default',
    color: 'white',
    _hover: {
      bg: 'primary.600',
      borderColor: 'primary.600',
      color: 'white',
      ...disabledButtonHoverStyle
    }
  },
  primaryOnDark: {
    bg: 'yellow.default',
    borderColor: 'yellow.default',
    color: 'black',
    _hover: {
      bg: 'yellow.500',
      borderColor: 'yellow.500',
      color: 'black',
      ...disabledButtonHoverStyle
    },
    _focus: {
      boxShadow: '0 0 0 3px rgba(255, 255, 255, 0.7)'
    }
  },
  secondary: {
    bg: 'white',
    borderColor: 'gray.medium',
    color: 'primary.default',
    _hover: {
      borderColor: 'primary.600',
      color: 'primary.600',
      ...disabledButtonHoverStyle
    }
  },
  secondaryOnDark: {
    bg: 'none',
    borderColor: 'white',
    color: 'white',
    _hover: {
      bg: 'white',
      borderColor: 'white',
      color: 'black',
      ...disabledButtonHoverStyle
    },
    _focus: {
      boxShadow: '0 0 0 3px rgba(255, 255, 255, 0.7)'
    }
  },
  tertiary: {
    bg: 'none',
    borderWidth: 'none',
    borderRadius: 'unset',
    color: 'primary.default',
    h: 'unset',
    m: 'unset',
    minW: 'unset',
    p: 'unset',
    lineHeight: 1,
    _disabled: {
      bg: 'none',
      color: 'gray.dark'
    },
    _hover: {
      color: 'primary.600',
      _disabled: {
        color: 'gray.dark'
      }
    }
  },
  tertiaryOnDark: {
    bg: 'none',
    borderRadius: 'unset',
    borderWidth: 'none',
    color: 'white',
    h: 'unset',
    m: 'unset',
    minW: 'unset',
    p: 'unset',
    _disabled: {
      bg: 'none',
      color: 'white',
      opacity: '.7'
    },
    _hover: {
      color: 'white',
      opacity: '.8',
      _disabled: {
        opacity: '.7'
      }
    }
  },
  destructive: {
    ...destructiveButtonStyles
  },
  destructiveOnDark: {
    ...destructiveButtonStyles
  }
};
const defaultProps = {
  size: null
};
var _default = exports.default = (0, _merge.default)(_theme.default.components.Button, {
  variants,
  baseStyle,
  defaultProps
});